module.exports = __webpack_public_path__ + "img/gal_21.9ff23555.png";